import React, { CSSProperties, ReactElement, useMemo } from "react";

import { Button, Modal } from "semantic-ui-react";

type ModConfirmOAProps = {
  approveButtonPosition?: "left" | "right";
  approveButtonText: string;
  denyButtonText: string;
  isLoading?: boolean;
  open: boolean;
  subtitle: ReactElement | string;
  title: string;
  onApprove?: () => void;
  onClose: () => void;
  onDeny: () => void;
};

type Styles = Record<
  "buttonContainer" | "container" | "primaryButton" | "secondaryButton" | "subtitle" | "title",
  CSSProperties
>;

const styles: Styles = {
  buttonContainer: {
    display: "flex",
    gap: "12px",
    marginTop: "1rem",
    width: "100%",
  },
  container: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    minWidth: "400px",
    padding: "3rem 2.5rem",
    textAlign: "center",
  },
  primaryButton: {
    backgroundColor: "var(--primary-theme-color)",
    borderRadius: "8px",
    color: "white",
    flex: 1,
    fontSize: "16px",
    padding: "12px 24px",
  },
  secondaryButton: {
    backgroundColor: "#f3f4f6",
    borderRadius: "8px",
    color: "#374151",
    flex: 1,
    fontSize: "16px",
    padding: "12px 24px",
  },
  subtitle: {
    color: "#374151",
    fontSize: "1.35rem",
    fontWeight: "400",
    marginBottom: "2rem",
  },
  title: {
    color: "var(--primary-theme-color)",
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
  },
};

const ModConfirmOA: React.FC<ModConfirmOAProps> = (props) => {
  const approveButton = useMemo(
    () => (
      <Button style={styles.primaryButton} loading={props.isLoading} onClick={props.onApprove}>
        {props.approveButtonText}
      </Button>
    ),
    [props.approveButtonText, props.isLoading, props.onApprove]
  );

  const denyButton = useMemo(
    () => (
      <Button style={styles.secondaryButton} onClick={props.onDeny}>
        {props.denyButtonText}
      </Button>
    ),
    [props.denyButtonText, props.onDeny]
  );

  return (
    <Modal
      style={{ borderRadius: "22px", width: "auto" }}
      open={props.open}
      closeOnDimmerClick
      onClose={props.onClose}
    >
      <div style={styles.container}>
        <h2 style={styles.title}>{props.title}</h2>

        <h2 style={styles.subtitle}>{props.subtitle}</h2>

        <div style={styles.buttonContainer}>
          {props.approveButtonPosition === "right" ? (
            <>
              {denyButton}
              {approveButton}
            </>
          ) : (
            <>
              {approveButton}
              {denyButton}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModConfirmOA;
